export const LOCALES = {
    ENGLISH: "eng",
    FRENCH: "fr",
    GERMAN: "de",
    SPANISH: "es",
    POLISH: "pl",
    JAPANESE: "jpn",
};
